module.exports = __webpack_public_path__ + "static/media/Lotto5.1e0cbcd8.png";